import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {AudioPlayerControlComponent} from '@app/shared/components/audio-player-control/audio-player-control.component';
import {AudioPlayerService} from '@app/shared/components/audio-player-control/audio-player.service';
import {PipService} from '@app/shared/components/video-player/pip.service';

import {HeaderComponent} from '../header/header.component';

@Component({
  selector: 'hypecast-base-layout',
  imports: [RouterOutlet, HeaderComponent, AudioPlayerControlComponent],
  templateUrl: './base-layout.component.html',
  styleUrl: './base-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseLayoutComponent {
  private readonly audioPlayerService = inject(AudioPlayerService);
  private readonly pipService = inject(PipService, {optional: true});

  protected readonly isControlsVisible = this.audioPlayerService.controlsVisible;

  protected isPipActive(): boolean {
    return this.pipService?.isPipActive() ?? false;
  }
}
